/* eslint-disable no-restricted-globals */
import { useMemo } from 'react';

import useForm from '../utils/useForm';
import SystemService from '../../services/SystemService';

const useDocumentForm = (onSubmit, values) => {
  const fields = useMemo(
    () => [
      {
        title: '',
        fields: [
          {
            title: 'Filename',
            name: 'name',
            type: 'text',
            required: true,
            postfix: '.pdf',
          },
          {
            title: 'Type',
            name: 'type',
            type: 'fetchableSelect',
            fetchOptions: {
              key: ['documentTypes'],
              queryFn: async () => {
                const types = await SystemService.getDocumentTypes();
                return types.map((type) => ({
                  id: type,
                  name: type,
                }));
              },
              labelKey: 'name',
            },
            required: true,
          },
          {
            title: 'Date',
            name: 'date',
            type: 'date',
          },
          {
            title: 'Description',
            name: 'description',
            type: 'textarea',
          },
        ],
      },
    ],
    []
  );

  return useForm({ fields, onSubmit, values });
};

export default useDocumentForm;
